export const RENTER_CANNOT_IDV_HELP_URL = 'https://zillow.zendesk.com/hc/en-us/articles/360001470207';
export const USER_NOT_FOUND_LOCKED_OUT_LINK = 'https://zillow.zendesk.com/hc/en-us/articles/360001510268';
export const EXPERIAN_DISPUTE_URL = 'https://www.experian.com/disputes/main.html';
export const CUSTOMER_SUPPORT_LINK = 'https://www.zillow.com/rental-manager/submit-request';
export const EXPERIAN_FROZEN_ACCOUNT_URL = 'https://www.experian.com/help/credit-freeze/';
export const EXPERIAN_CONNECT_FAQ_URL = 'http://www.experian.com/connect/frequently-asked-questions.html#howdoesthe';
